import { EClassicPhase } from '../../../enums';

export const CLASSIC_PHASE_DURATIONS = {
  [EClassicPhase.COUNTDOWN]: 55000, // Фаза размещения игроками ставок (отсчет времени до рулетки)
  [EClassicPhase.RAFFLING]: 16000, // Фаза розыгрыша (рулетка)
  [EClassicPhase.PRIZES]: 7000, // Фаза, в которой отображаются все данные о розыгрыше (сумма выигрыша и победитель)
  [EClassicPhase.RESETTING]: 1000, // Фаза сброса игры в начальное состояние (сокрытие всех сообщений, ставок)
} as const;
